import { parseIntM } from '@execonline-inc/numbers';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Route, Switch } from 'react-router-dom';
import Registration from '../../../../../src/DiscoveryPortal/Registration';
import {
  allExperiences,
  dynamicRecommendation,
  FromState,
  learningDesign,
  none,
  recEngine,
} from '../../DiscoveryContext';
import ExperienceDetailView from '../../ExperienceDetailView';
import LicensePurchaseShelf from '../../Common/LicensePurchase/Views/LicensePurchaseShelf';
import ExperienceSelection from '../ExperienceSelection';
import ExperiencesStore from '../ExperienceSelection/Experiences/ExperiencesStore';
import { RegisterResource } from '../RegisterResourceStore/Types';
import GoToProgram from './GoToProgram';
import EnrollmentStore from './Store';

interface Props {
  registerResource: RegisterResource;
  enrollmentStore: EnrollmentStore;
  experiencesStore: ExperiencesStore;
}

const fromProductCollection =
  (toState: (productCollectionId: number) => FromState) =>
  (productCollectionId: string): FromState =>
    parseIntM(productCollectionId).map(toState).getOrElseValue(none());

const Routes: React.FC<Props> = ({ registerResource, enrollmentStore, experiencesStore }) => (
  <>
    {/* License purchase (DVLP-7860): one dialog and one offer shelf shared by the
        collection page and every course page. /preview/:id never matches, so an
        admin preview loads no offers. */}
    <Route
      path="/register/:uuid"
      render={(props) => (
        <LicensePurchaseShelf
          invitationUuid={props.match.params.uuid}
          registerResource={registerResource}
        />
      )}
    />
    <Switch>
      <Route
        path="/preview/:id"
        exact={true}
        render={(props) => (
          <ExperienceSelection
            invitationUuid={props.match.params.id}
            enrollmentStore={enrollmentStore}
            experiencesStore={experiencesStore}
            registerResource={registerResource}
          />
        )}
      />
      <Route
        path="/register/:uuid"
        exact={true}
        render={(props) => (
          <ExperienceSelection
            invitationUuid={props.match.params.uuid}
            enrollmentStore={enrollmentStore}
            experiencesStore={experiencesStore}
            registerResource={registerResource}
          />
        )}
      />
      <Route
        path="/registration/:uuid"
        render={(props) => <Registration guid={props.match.params.uuid} />}
      />
      <Route
        path="/register/:uuid/experience/:experienceId/from/learningDesign/:productCollectionId"
        exact={true}
        render={(props) => (
          <ExperienceDetailView
            experienceId={props.match.params.experienceId}
            invitationUuid={props.match.params.uuid}
            registerResource={registerResource}
            enrollmentStore={enrollmentStore}
            experiencesStore={experiencesStore}
            discoveryReferenceState={fromProductCollection(learningDesign)(
              props.match.params.productCollectionId,
            )}
          />
        )}
      />
      <Route
        path="/register/:uuid/experience/:experienceId/from/rec/:productCollectionId"
        exact={true}
        render={(props) => (
          <ExperienceDetailView
            experienceId={props.match.params.experienceId}
            invitationUuid={props.match.params.uuid}
            registerResource={registerResource}
            enrollmentStore={enrollmentStore}
            experiencesStore={experiencesStore}
            discoveryReferenceState={fromProductCollection(recEngine)(
              props.match.params.productCollectionId,
            )}
          />
        )}
      />
      <Route
        path="/register/:uuid/experience/:experienceId/from/dynamicRecommendation/:productCollectionId"
        exact={true}
        render={(props) => (
          <ExperienceDetailView
            experienceId={props.match.params.experienceId}
            invitationUuid={props.match.params.uuid}
            registerResource={registerResource}
            enrollmentStore={enrollmentStore}
            experiencesStore={experiencesStore}
            discoveryReferenceState={fromProductCollection(dynamicRecommendation)(
              props.match.params.productCollectionId,
            )}
          />
        )}
      />
      <Route
        path="/register/:uuid/experience/:experienceId/from/all"
        exact={true}
        render={(props) => (
          <ExperienceDetailView
            experienceId={props.match.params.experienceId}
            invitationUuid={props.match.params.uuid}
            registerResource={registerResource}
            enrollmentStore={enrollmentStore}
            experiencesStore={experiencesStore}
            discoveryReferenceState={allExperiences()}
          />
        )}
      />
      <Route
        path="/register/:uuid/experience/:experienceId"
        exact={true}
        render={(props) => (
          <ExperienceDetailView
            experienceId={props.match.params.experienceId}
            invitationUuid={props.match.params.uuid}
            registerResource={registerResource}
            enrollmentStore={enrollmentStore}
            experiencesStore={experiencesStore}
            discoveryReferenceState={none()}
          />
        )}
      />
      <Route
        path="/register/:uuid/experience/:experienceId/now"
        exact={true}
        render={(props) => (
          <GoToProgram
            experienceId={props.match.params.experienceId}
            invitationUuid={props.match.params.uuid}
            registerResource={registerResource}
            enrollmentStore={enrollmentStore}
            experiencesStore={experiencesStore}
          />
        )}
      />
    </Switch>
  </>
);

export default observer(Routes);
